
import {ComponentEnum} from "@/config/config-types";
import TaxonPicker from "@/components/picker/TaxonPicker.vue";
import NumberPicker from "@/components/picker/NumberPicker.vue";
import BooleanPicker from "@/components/picker/BooleanPicker.vue";
import ImagePicker from "@/components/picker/ImagePicker.vue";
import SpecimenPicker from "@/components/picker/SpecimenPicker.vue";
import CategoryPicker from "@/components/picker/CategoryPicker.vue";
import StringPicker from "@/components/picker/StringPicker.vue";
import PersonPicker from "@/components/picker/PersonPicker.vue";
import ConfirmPopup from 'primevue/confirmpopup';
import {defineComponent} from "vue";
import Button from "primevue/button";
import Card from "primevue/card";
import Message from "primevue/message";
import Panel from "primevue/panel";
import InfoButton from "@/components/legend/InfoButton.vue";
import {lookupURL, taxonByIdURL} from "@/config/app-settings";
import axios from "axios";

export default defineComponent({
  name: "LichenRecordForm",
  components: {
    StringPicker,
    CategoryPicker,
    SpecimenPicker,
    ImagePicker, BooleanPicker, NumberPicker, TaxonPicker, PersonPicker, InfoButton,
    Button, Card, Message, Panel, ConfirmPopup
  },
  data() {
    return {
      ComponentEnum,
      isCollapsed: false,
      removeRequested: false,
      taxonNameDict: {}
    }
  },
  computed: {
    rec(): any {
      return this.$store.state.lichenRecordForm.records
    }
  },
  watch: {
    rec() {
      this.getDisplayName()
    }
  },
  props: {
    recordIdx: Number,
    record: Object,
  },
  methods: {
    select(val: any) {
      this.$store.commit('setLichenRecordValue', {idx: this.recordIdx, key: val.key, value: val.value})
      if (val.key == 'taxonReferenceSuggested.taxonId') {
        this.getDisplayName()
      }
    },
    remove(event: any) {
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('form.confirmDeleteRecord'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.$store.commit('removeLichenRecord', this.recordIdx)
        }
      });
    },
    getDisplayName() {
      this.$store.state.lichenRecordForm.records.forEach((rec: any, idx: any) => {
        let taxonId = rec.find((f: any) => f.name === 'taxonReferenceSuggested').value.find((fg: any) => fg.name === 'taxonId').value
        if (taxonId) {
          axios.get(taxonByIdURL + '?taxonId=' + taxonId)
              .then((res) => {
                    // @ts-ignore
                    this.taxonNameDict[idx] = res.data[0].LABEL
                  }
              )
              .catch(e => console.log(e))
        }
      })


    }
  },
  mounted() {
    this.getDisplayName()
  }
})
